export const PAGE_TYPE = "page";
export const LINK_TYPE = "link";
export const ACTION_TYPE = "action";
export const ENTITY_TYPE = "entity";
export const PAGE_WEIGHT = 0.99;
export const BASE_SCORE = 100;
export const LAST_OPENED_ITEMS_LOOKBACK = 50;
export const FEATURE_FLAG = "quick_jump";
